import DefaultRouter from './default';
import PondRouter from './pond';
import VisitRouter from './visit';
import PageRouter from './page';
import UserRouter from './user';
import ImageRouter from './image';
// import VisitRouter from './visit';

export default {
	default: DefaultRouter,
	pond: PondRouter,
	visit: VisitRouter,
	page: PageRouter,
	user: UserRouter,
	image: ImageRouter
};
